export const HAULIERS = {
  DPMP: 'dpmp',
  NITRA: 'nitra',
  TRENCIN: 'trencin',
  RUZOMBEROK: 'ruzomberok',
  DPB: 'dpb',
  LOCAL: 'local',
  POLAND: 'poland',
  VISEUDESUS: 'viseudesus',
  DPMO: 'dpmo',
  DPMLB: 'dpmlb',
};

export const MIGRATION_FLAGS = {
  TELSHOP: 'TELSHOP',
};

export const MAX_DECIMAL_POSITIONS = 2;
